export default __webpack_public_path__ + "static/causa-global-vision-9abcd9f7802f5dc0f90a02c8001d4a7a.png";